import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ontos-field-label" }
const _hoisted_2 = { class: "text-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_ask_dialog = _resolveComponent("ontos-ask-dialog")!

  return (_ctx.shown)
    ? (_openBlock(), _createBlock(_component_ontos_ask_dialog, {
        key: 0,
        title: _ctx.$tt('change-refused'),
        message: _ctx.shown.message,
        icon: "mdi-alert-circle",
        "icon-color": "error",
        actions: _ctx.actions,
        onPick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPick($event))),
        onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          (_ctx.shown.fields.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.shown.fields, (failure, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "refusal-field"
                }, [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(failure.field), 1),
                  _createElementVNode("div", _hoisted_2, _toDisplayString(failure.message), 1)
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.shown.message), 1)
              ], 64))
        ]),
        _: 1
      }, 8, ["title", "message", "actions"]))
    : _createCommentVNode("", true)
}